let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aT9no")).then(() => parcelRequire('d2QPY'));